/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react"; // React Stuff
import { BrowserView, MobileView } from "react-device-detect"; // Device Detection for two views
import FadeIn from "../common/FadeIn";
import { Link, Navigate } from "react-router-dom";
//Packages
import axios from "axios";
import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";
import { isAuthenticated } from "./services/auth"; //import auth
//TimeRendering
import Moment from "react-moment";
//Loading
import LoadingSpinner from "../LoadingSpinner";
// Icon Library
import { MdFastForward, MdFastRewind } from "react-icons/md";

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [searchMode, setSearchMode] = useState(
    JSON.parse(window.localStorage.getItem("customerSearchPreference"))
  );
  const [searchString, setSearchString] = useState("");
  const [currentPage, setCurrentPage] = useState(0); // For Pagination

  // Get the Customer & Participant Details
  useEffect(async () => {
    const customerListRequest = await axios.get(`/api/admin/manage/customers`, {
      withCredentials: true,
    });
    return setCustomers(customerListRequest.data);
  }, []);

  return (
    <div className='CustomerList'>
      <FadeIn delay={250} duration={450}>
        {isAuthenticated() ? (
          <div>
            <Container>
              <SearchBox
                setSearchString={setSearchString}
                setSearchMode={setSearchMode}
                setCurrentPage={setCurrentPage}
                searchMode={searchMode}
              />
              {(searchMode === null || searchMode === "customer") && (
                <CustomerListTable
                  customers={customers}
                  currentPage={currentPage}
                  searchString={searchString}
                  setCurrentPage={setCurrentPage}
                />
              )}
              {searchMode === "participant" && (
                <ParticipantListTable
                  customers={customers}
                  currentPage={currentPage}
                  searchString={searchString}
                  setCurrentPage={setCurrentPage}
                />
              )}
              <ExportsBlock/>
            </Container>
          </div>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};

const CustomerListTable = (props) => {
  const setCurrentPage = props.setCurrentPage;
  const currentPage = props.currentPage;
  const searchString = props.searchString;
  const customers = props.customers;
  // Filter out people who haven't set their details 
  const customerListRemoveBlanks = customers.filter(
    (t) => t.Last_Name !== undefined
  );

  // Search the result or display unfilteed
  let customerListToRender;
  if (searchString.length <= 2) {
    customerListToRender = customerListRemoveBlanks;
  } else if (searchString.length >= 3) {
    customerListToRender = customerListRemoveBlanks.filter(function (o) {
      return Object.keys(o).some(function (k) {
        return o[k].toString().toLowerCase().indexOf(searchString) !== -1;
      });
    });
  }

  //maxPage Number for pagination
  const maxPageNumber = Math.ceil(customerListToRender.length / 20);
  // Slice the page results for Pagination
  const sliceStart = currentPage * 20;
  const sliceEnd = sliceStart + 20;

  // Final List based on if search or pagination are being used and sort alphabetically
  let finalList;
  if (searchString >= 2) {
    finalList = customerListToRender.sort((a, b) => {
      return a.Last_Name.localeCompare(b.Last_Name);
    });
  } else {
    finalList = customerListToRender.slice(sliceStart, sliceEnd).sort((a, b) => {
      return a.Last_Name.localeCompare(b.Last_Name);
    });
  }
  return (
    <>
      {finalList.length >= 0 ? (
        <div>
          <BrowserView>
            <Row>
              <Col>
                <Table striped bordered hover responsive size='sm' className='text-center mb-4'>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Participants</th>
                      <th>Stripe ID</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {finalList.map((customer) => (
                      <tr key={customer._id}>
                        <td className='align-self-center align-middle'>
                          <small>{customer.First_Name + " " + customer.Last_Name}</small>
                        </td>
                        <td className='align-self-center align-middle'>
                          <small>{customer.email}</small>
                        </td>
                        <td className='align-self-center align-middle'>
                          <ul className='list-group list-group-flush'>
                            {customer.Participants.map((participant) => (
                              <li className='list-group-item' key={participant._id}>
                                <small>
                                  {participant.First_Name + " " + participant.Last_Name}
                                </small>
                              </li>
                            ))}
                          </ul>
                        </td>
                        <td className='align-self-center align-middle'>
                          <small>
                            <a
                              target='_blank'
                              rel='noopener noreferrer'
                              href={`https://dashboard.stripe.com/customers/${customer.stripe_customer_id}`}
                            >
                              {customer.stripe_customer_id}
                            </a>
                          </small>
                        </td>
                        <td className='align-self-center align-middle'>
                          <Button
                            varian='info'
                            size='sm'
                            as={Link}
                            type='link'
                            to={`/admin/customer-list/${customer._id}`}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <PaginationButtons
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  maxPageNumber={maxPageNumber}
                />
              </Col>
            </Row>
          </BrowserView>
          <MobileView>
            {searchString.length >= 2 && (
              <Row>
                {finalList.map((customer) => (
                  <Col key={customer._id} sm='12'>
                    <FadeIn delay={50} duration={450}>
                      <div className='mx-1 mt-3 p-2 shadow border text-center'>
                        <h5>{customer.First_Name + " " + customer.Last_Name}</h5>
                        <p>
                          <small>{customer.email}</small>
                          <hr />
                          <h6>Participants</h6>
                          <ul className='list-group list-group-flush'>
                            {customer.Participants.map((participant) => (
                              <li className='list-group-item' key={participant._id}>
                                <small>
                                  {participant.First_Name + " " + participant.Last_Name}
                                </small>
                              </li>
                            ))}
                          </ul>
                          <hr />
                          <Button
                            varian='info'
                            size='sm'
                            as={Link}
                            type='link'
                            to={`/admin/customer-list/${customer._id}`}
                          >
                            View
                          </Button>
                        </p>
                      </div>
                    </FadeIn>
                  </Col>
                ))}
              </Row>
            )}
          </MobileView>
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

const ParticipantListTable = (props) => {
  const setCurrentPage = props.setCurrentPage;
  const currentPage = props.currentPage;
  const searchString = props.searchString;
  const customers = props.customers;
  // Filter out people who haven't set their details or Participants
  const customerListRemoveBlanks = customers.filter(
    (t) => t.Last_Name !== undefined || t.Participants.length > 0
  );

  const participantsOnly = customerListRemoveBlanks.map((item) => item.Participants);
  const flattenedParticipants = [].concat.apply([], participantsOnly);

  // Search the result or display unfilteed
  let participantListToRender;
  if (searchString.length <= 2) {
    participantListToRender = flattenedParticipants;
  } else if (searchString.length >= 3) {
    participantListToRender = flattenedParticipants.filter(function (a) {
      return Object.keys(a).some(function (b) {
        return a[b].toString().toLowerCase().indexOf(searchString) !== -1;
      });
    });
  }

  //maxPage Number for pagination
  const maxPageNumber = Math.ceil(participantListToRender.length / 20);
  // Slice the page results for Pagination
  const sliceStart = currentPage * 20;
  const sliceEnd = sliceStart + 20;

  // Final List based on if search or pagination are being used and sort alphabetically
  let finalList;
  if (searchString >= 2) {
    finalList = participantListToRender.sort((a, b) => {
      return a.Last_Name.localeCompare(b.Last_Name);
    });
  } else {
    finalList = participantListToRender.slice(sliceStart, sliceEnd).sort((a, b) => {
      return a.Last_Name.localeCompare(b.Last_Name);
    });
  }

  return (
    <>
      {finalList.length >= 0 ? (
        <div>
          <BrowserView>
            <Row>
              <Col>
                <Table striped bordered hover responsive size='sm' className='text-center mb-4'>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Age</th>
                      <th>Contact 1</th>
                      <th>Contact 2</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {finalList.map((participant) => (
                      <tr key={participant._id}>
                        <td className='align-self-center align-middle'>
                          <small>{participant.First_Name + " " + participant.Last_Name}</small>
                        </td>
                        <td className='align-self-center align-middle'>
                          <small>
                            <Moment format='Y [year], M [months]' durationFromNow ago>
                              {participant.Date_Of_Birth}
                            </Moment>{" "}
                            old ({participant.Date_Of_Birth})
                          </small>
                        </td>
                        <td className='align-self-center align-middle'>
                          <small>
                            {participant.Emergency_Contact_1_Contact_Number} (
                            {participant.Emergency_Contact_1_Name})
                          </small>
                        </td>
                        <td className='align-self-center align-middle'>
                          <small>
                            {participant.Emergency_Contact_2_Contact_Number} (
                            {participant.Emergency_Contact_2_Name})
                          </small>
                        </td>
                        <td className='align-self-center align-middle'>
                          <Button
                            varian='info'
                            size='sm'
                            as={Link}
                            type='link'
                            to={`/admin/customer-list/${participant.SystemUserID}`}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <PaginationButtons
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  maxPageNumber={maxPageNumber}
                />
              </Col>
            </Row>
          </BrowserView>
          <MobileView>
            {searchString.length >= 2 && (
              <Row>
                {finalList.map((participant) => (
                  <Col key={participant._id} sm='12'>
                    <FadeIn delay={50} duration={450}>
                      <div className='mx-1 mt-3 p-2 shadow border text-center'>
                        <h5>{participant.First_Name + " " + participant.Last_Name}</h5>
                        <p>
                          <small>
                            {" "}
                            <Moment format='Y [year], M [months]' durationFromNow ago>
                              {participant.Date_Of_Birth}
                            </Moment>{" "}
                            old ({participant.Date_Of_Birth})
                          </small>
                          <hr />
                          <Button
                            varian='info'
                            size='sm'
                            as={Link}
                            type='link'
                            to={`/admin/customer-list/${participant.SystemUserID}`}
                          >
                            View
                          </Button>
                        </p>
                      </div>
                    </FadeIn>
                  </Col>
                ))}
              </Row>
            )}
          </MobileView>
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

const PaginationButtons = (props) => {
  const pageNow = props.currentPage;
  const maxPageNumber = props.maxPageNumber;
  let pageNext;
  const goBackAPage = (e) => {
    e.preventDefault();
    if (pageNow < maxPageNumber) {
      pageNext = pageNow - 1;
    } else {
      pageNext = pageNow;
    }
    window.scrollTo(10, 0);
    return props.setCurrentPage(pageNext);
  };

  const goToNextPage = (e) => {
    e.preventDefault();
    if (pageNow < maxPageNumber) {
      pageNext = pageNow + 1;
    } else {
      pageNext = pageNow;
    }
    window.scrollTo(10, 0);
    return props.setCurrentPage(pageNext);
  };

  return (
    <>
      {pageNow > 0 && (
        <Button variant='primary' type='button' className='me-3' onClick={goBackAPage}>
          Previous Page ({(pageNow + 1) - 1}) <MdFastRewind />
        </Button>
      )}
      {maxPageNumber > 0 && pageNow !== maxPageNumber - 1 && (
        <Button variant='primary' type='button' className='me-3' onClick={goToNextPage}>
          Next Page ({pageNow + 2}) <MdFastForward />
        </Button>
      )}
    </>
  );
};

const SearchBox = (props) => {
  const [localSearchString, setLocalSearchString] = useState("");
  //For the Title
  let titleString;
  if (props.searchMode === "participant") {
    titleString = "Search by Participants";
  } else {
    titleString = "Search by Customers";
  }
  // For the box
  const submitHandler = (e) => {
    e.preventDefault();
    props.setCurrentPage(0); // Reset the current page.
    return props.setSearchString(localSearchString.toLowerCase());
  };
  // change Search mode

  const changeSearchMode = (mode, e) => {
    e.preventDefault();
    props.setCurrentPage(0);
    setLocalSearchString(""); // Reset the Search String
    props.setSearchString("")// Reset the global search string.
    localStorage.setItem("customerSearchPreference", JSON.stringify(mode));
    return props.setSearchMode(mode);
  };
  return (
    <Row>
      <Col>
        <div className='mt-3 mb-3 shadow border p-3 text-center'>
          <h3>{titleString}</h3>
          <Form onSubmit={submitHandler}>
            <Form.Group controlId='EmailSearchForm'>
              <Form.Control
                type='text'
                maxLength='256'
                value={localSearchString}
                onChange={(e) => setLocalSearchString(e.target.value)}
                placeholder='Smith'
                className='border'
              />
            </Form.Group>
            <p>
              Filter data by typing a single search string like last name (e.g Smith), telephone
              number or stripe id.
            </p>
            <Button variant='success' className='mt-3 mb-3 w-100' type='submit'>
              Search
            </Button>
          </Form>
          {props.searchMode === "participant" ? (
            <Button
              variant='secondary'
              className='mt-3 mb-3 w-100'
              type='submit'
              value={"customer"}
              onClick={(e) => changeSearchMode(e.target.value, e)}
            >
              Change to Customer Details Mode
            </Button>
          ) : (
            <Button
              variant='secondary'
              className='mt-3 mb-3 w-100'
              type='submit'
              value={"participant"}
              onClick={(e) => changeSearchMode(e.target.value, e)}
            >
              Change to Participant Details Mode
            </Button>
          )}
        </div>
      </Col>
    </Row>
  );
};

const ExportsBlock = () => {
  const exportCustomers = async () => {
    const exportRequest = await axios.get(`/api/admin/manage/customers_export`, {
      withCredentials: true,
    });
    const url = window.URL.createObjectURL(new Blob([exportRequest.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "customers_export.csv");
    document.body.appendChild(link);
    link.click();
  };

  const exportCustomersForRetarget = async () => {
    const exportAbandonersRequest =    await axios
    .get(`/api/admin/manage/customers_export/not_set_up`, {
      withCredentials: true,
    })
    const url = window.URL.createObjectURL(new Blob([exportAbandonersRequest.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "customers_export.csv");
    document.body.appendChild(link);
    link.click();
  };

  return (
    <Row>
      <Col>
        <div className='mt-3 mb-3 shadow border p-3 text-center'>
          <h3>Export Customer Contact Details</h3>
          <p>
            You can export all customer contact details to import into your mailing list provider or
            other marketing tool.
          </p>
          <Button variant='secondary' className='w-100 mt-3 mb-3' onClick={exportCustomers}>
            Export
          </Button>
          <hr/>
          <h3>Export Abandoners</h3>
          <p>
            You can export customers which signed up for your business but did not subscribe for manual retargeting. 
          </p>
          <Button variant='secondary' className='w-100 mt-3 mb-3' onClick={exportCustomersForRetarget}>
            Export
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default CustomerList;
